const links = [
    {
        label: 'Github',
        url: 'https://github.com/developer-kishi'
    },
    {
        label: 'Twitter',
        url: 'https://twitter.com/developer-kishi'
    },
    {
        label: 'Facebook',
        url: 'https://www.facebook.com/profile.php?id=100011372454903'
    }
]
export default links